/*
 * File: DraftIdSearch.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 16 Dec 2021 11:35:12 am
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Space } from 'antd';
import { FancyInput } from 'components/atoms/FancyInput';
import React, { ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { setFilterDraftId } from 'redux/salesOrder/ordersSlice';
import { useDebouncedCallback } from 'use-debounce';

export const DraftIdSearch = (): JSX.Element => {
  const dispatch = useDispatch();

  /* ****************** Functions ****************** */
  // Handle delay of searching data
  const handleInputChange = useDebouncedCallback((ev: ChangeEvent<HTMLInputElement>) => {
    dispatch(setFilterDraftId(ev.target.value));
  }, 500);

  /* ****************** Render ****************** */
  return (
    <Space direction="vertical" size="small">
      <FancyInput placeholder="Draft Id" onChange={handleInputChange} width={150} />
    </Space>
  );
};
